import * as React from 'react';

const PUMPKIN_PATH =
  'M10.695.211c5.907 0 10.695 4.82 10.695 10.765S16.602 21.74 10.695 21.74 0 16.921 0 10.975 4.788.211 10.695.211z';
const TOP_PATCH_PATH =
  'M29.305 0C35.212 0 40 4.819 40 10.765c0 2.572-.897 4.934-2.392 6.786a.74.74 0 0 1-1.105.048L22.515 3.519c-.306-.308-.302-.826.047-1.112A10.61 10.61 0 0 1 29.305 0z';
const MIDDLE_PATCH_PATH =
  'M21.154 4.609c.084-.063.179-.032.297.087l13.952 14.042c.248.25.36.543.112.793l-6.786 6.83c-.248.25-.651.25-.9 0l-6.857-6.902a.66.66 0 0 1-.093-.799c3.078-5.191 1.701-10.766.225-13.739-.073-.147-.034-.25.05-.313z';
const BOTTOM_PATCH_PATH =
  'M19.42 20.827c.25-.274.571-.186.838.082l6.494 6.536c.248.25.36.543.112.793l-6.532 6.574c-.248.25-.651.25-.9 0l-8.24-8.293c-.196-.198-.226-.47-.145-.696s.276-.419.545-.464c3.486-.586 6.431-2.996 7.829-4.532z';

const PURPLE = '#7740b5';
const LAVENDER = '#a77cd4';
const LIME = '#68a134';
const ORANGE = '#ca6b17';
const STITCH = '#2a1b3d';

interface Patch {
  key: string;
  path: string;
  base: string;
  shade: string;
  shadePoints: string;
  seam: [number, number, number, number];
}

const PATCHES: Patch[] = [
  {
    key: 'top',
    path: TOP_PATCH_PATH,
    base: LAVENDER,
    shade: PURPLE,
    shadePoints: '27,0.5 39,13 42,13 42,-2 27,-2',
    seam: [27, 0.5, 39, 13]
  },
  {
    key: 'middle',
    path: MIDDLE_PATCH_PATH,
    base: ORANGE,
    shade: LIME,
    shadePoints: '21,12 32,23 40,15 25,0',
    seam: [21.5, 12.5, 31.5, 22.5]
  },
  {
    key: 'bottom',
    path: BOTTOM_PATCH_PATH,
    base: ORANGE,
    shade: PURPLE,
    shadePoints: '14,30 24,24.5 30,30 20,38 8,30',
    seam: [14, 30, 24, 24.5]
  }
];

const SpookyMaticLogo = (props: React.SVGProps<SVGSVGElement>) => {
  const id = React.useId();
  const pumpkinGradientId = `${id}-pumpkin`;

  return (
    <svg width={40} height={35} viewBox="-1 -3.5 42 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <radialGradient id={pumpkinGradientId} cx="40%" cy="40%" r="65%">
          <stop offset="0%" stopColor="#ffb347" />
          <stop offset="100%" stopColor="#e8620c" />
        </radialGradient>
        {PATCHES.map(patch => (
          <clipPath key={patch.key} id={`${id}-${patch.key}`}>
            <path d={patch.path} />
          </clipPath>
        ))}
      </defs>

      {PATCHES.map(patch => (
        <g key={patch.key} clipPath={`url(#${id}-${patch.key})`}>
          <path d={patch.path} fill={patch.base} />
          <polygon points={patch.shadePoints} fill={patch.shade} />
          <line
            x1={patch.seam[0]}
            y1={patch.seam[1]}
            x2={patch.seam[2]}
            y2={patch.seam[3]}
            stroke={STITCH}
            strokeWidth={1.2}
            strokeDasharray="0.35 1.1"
          />
        </g>
      ))}

      <path d="M10.2 1.2c-.2-1.6.3-3.2 1.2-4.2l1 .5c-.7.9-1 2.3-.9 3.7z" fill="#4c9a2a" />
      <path d={PUMPKIN_PATH} fill={`url(#${pumpkinGradientId})`} />
      <g stroke="#c4500a" strokeWidth={0.5} fill="none" opacity={0.7}>
        <path d="M10.7.4c-3 3-3 18 0 21.2" />
        <path d="M10.7.4c3 3 3 18 0 21.2" />
        <path d="M6 1.6c-3.2 3.5-3.2 15.2 0 18.8" />
        <path d="M15.4 1.6c3.2 3.5 3.2 15.2 0 18.8" />
      </g>
      <g fill="#ffe08a">
        <polygon points="4.6,9.6 8.4,9.6 7.4,6.4" />
        <polygon points="13,9.6 16.8,9.6 14,6.4" />
        <polygon points="9.9,12.6 11.5,12.6 10.7,11" />
        <path d="M4 13.6c2.2 4.6 11.2 4.6 13.4 0c-1.2.9-2.6 1.3-3.8 1.4l-.6 1.1-.7-1c-1.1.1-2.2.1-3.3 0l-.7 1-.6-1.1c-1.2-.1-2.5-.5-3.7-1.4z" />
      </g>
    </svg>
  );
};

export default SpookyMaticLogo;
